import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import styles from '../pdfStyles';
import { PdfMultipleTextBoxData } from '../Vouchers/voucherHelpers';

type Props = {
    title?: string;
    pdfMultipleTextBoxData: PdfMultipleTextBoxData;
    borderStyle?: { [key: string]: string };
};

const PdfMultipleTextBox: FC<Props> = (props: Props) => {
    const { pdfMultipleTextBoxData, title, borderStyle } = props;

    if (!pdfMultipleTextBoxData?.[0]?.length) {
        return <></>;
    }
    return (
        <View style={[styles.section, styles.flexRow, styles.marginBottom10px]} wrap={false}>
            <View style={[styles.border, styles.padding2px4px, borderStyle || {}]}>
                {title ? <Text style={[styles.fontSizePlus2, styles.width100]}>{title}:</Text> : <></>}
                <View style={[styles.flexRow]}>
                    {pdfMultipleTextBoxData.map((strings, stringsIdx) => {
                        return (
                            <View
                                key={`${stringsIdx}`}
                                style={[stringsIdx === 0 ? {} : styles.paddingLeft10]}
                            >
                                {strings.map((string, idx) => {
                                    return <Text key={`${stringsIdx}-${idx}`}>{string}</Text>;
                                })}
                            </View>
                        );
                    })}
                </View>
            </View>
        </View>
    );
};

export default memo(PdfMultipleTextBox);
